var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header",style:([{ maxHeight: _vm.threshold + 100 + 'px' }])},[_c('div',{staticClass:"a1"}),_c('div',{staticClass:"a2"},[_c('div',{style:([{ height: _vm.threshold + 'px' }])}),_c('h2',{attrs:{"id":"title"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }